var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContractTemplateEditor',{attrs:{"turnalFlag":"add"},on:{"submitSuccess":_vm.submitSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }